import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
var rule = [{
  key: 'province',
  name: '省份'
}, {
  key: 'details',
  name: '详细地址'
}, {
  key: 'phoneNumber',
  name: '联系电话',
  validator: 'validatePhone'
}, {
  key: 'contactName',
  name: '联系人'
}];
export default {
  meta: {
    title: '修改发货地址',
    auth: true,
    authorityValue: "store-delivery-address"
  },
  name: 'editSendShopp',
  data: function data() {
    return {
      // 表单
      formData: {
        province: '',
        city: '',
        district: '',
        details: '',
        postCode: '',
        phoneNumber: '',
        contactName: '',
        defaultAddress: false,
        addressType: 2,
        addressId: null
      },
      // 表单校验
      rules: utilRules(rule)
    };
  },
  created: function created() {
    var query = this.$route.query;
    this.getDetail(query);
  },
  methods: {
    getDetail: function getDetail(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(data);
                _context.next = 3;
                return _this.$api.addressDetails(data);

              case 3:
                res = _context.sent;
                _this.formData = _objectSpread(_objectSpread(_objectSpread({}, _this.formData), res), {}, {
                  addressId: data.addressId
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 3;
                  return _this2.$api.saveAddress(_this2.formData);

                case 3:
                  _this2.$notify.success({
                    title: '成功',
                    message: '修改成功'
                  });

                  _this2.goBack();

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.formData, 'province', e[0]);
      e[1] && this.$set(this.formData, 'city', e[1]);
      e[2] && this.$set(this.formData, 'district', e[2]);
      this.$refs.formData.validateField('province');
    }
  }
};